import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { TournamentCard } from "@/components/landing/TournamentCard";

export const UpcomingTournaments = () => {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/public/tournaments/upcoming", { params: { limit: 6 } }).then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);
  if (!data || data.items.length === 0) return null;
  return (
    <section id="upcoming" className="max-w-7xl mx-auto px-5 sm:px-8 pb-20" data-testid="upcoming-tournaments">
      <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="text-xs tracking-[0.25em] uppercase font-bold text-primary-c">Upcoming Tournaments</span>
          <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl mt-3">Find your next draw.</h2>
        </div>
        <button data-testid="upcoming-see-all" onClick={() => nav("/events")} className="inline-flex items-center gap-2 font-bold text-primary-c hover:gap-3 transition-all">
          See all {data.total} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {data.items.map((t, i) => <TournamentCard key={t.tournament_id} t={t} i={i} />)}
      </div>
    </section>
  );
};
